// extracted by mini-css-extract-plugin
module.exports = {"page1":"Page9_page1__2only","bg":"Page9_bg__2q8zf","text":"Page9_text__2Wwv4","bg2":"Page9_bg2__Kvhyg","imgContent":"Page9_imgContent__3q8Jc"};